// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__14foP","selected":"Chip_selected__1Lku1"};